import React, { useEffect, useState } from 'react'
import CasesListView from './components/CasesListView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const CasesList = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('listed-cases', 'Make a Restitution Payment', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <CasesListView setIsError={setIsError} />
}

export default withTranslation('common')(CasesList)
